import { render, staticRenderFns } from "./square.vue?vue&type=template&id=76a831d2&scoped=true"
import script from "./square.vue?vue&type=script&lang=ts"
export * from "./square.vue?vue&type=script&lang=ts"
import style0 from "./square.vue?vue&type=style&index=0&id=76a831d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a831d2",
  null
  
)

export default component.exports